import React, { useEffect, useState } from 'react';
import './App.css';

import CambridgePapers from "./CambridgePapers";
import EdexcelPapers from "./EdexcelPapers";
import IGCSEPapers from "./IGCSEPapers";
import Disclaimer from "./Disclaimer";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";
import CookiesPolicy from "./CookiesPolicy";

function App() {
  const [route, setRoute] = useState<string>(window.location.hash || '#/cambridgealevelpapers');

  useEffect(() => {
    const onHash = () => setRoute(window.location.hash || '#/cambridgealevelpapers');
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (route === '#/igcsepapers') {
    return <IGCSEPapers />;
  }

  if (route === '#/edexcelalevelpapers') {
    return <EdexcelPapers />;
  }

  if (route === '#/disclaimer') {
    return <Disclaimer />;
  }

  if (route === '#/privacy') {
    return <PrivacyPolicy />;
  }

  if (route === '#/terms') {
    return <TermsOfUse />;
  }

  if (route === '#/cookies') {
    return <CookiesPolicy />;
  }

  return <CambridgePapers />;
}

export default App;
